import { create } from 'zustand';

import { createTerminalSlice } from './actions';
import { TerminalSessionState, TerminalStore } from './types';
import { sessionNeedsYou } from '../../components/Terminal/utils/terminalStatus';

export const useTerminalStore = create<TerminalStore>()((set, get, store) => ({
  ...createTerminalSlice(set, get, store),
}));

export const useTerminalNeedsAttention = (): boolean =>
  useTerminalStore((state) =>
    Object.values(state.sessions).some(sessionNeedsYou),
  );

export const useActiveTerminalSession = (): TerminalSessionState | null =>
  useTerminalStore((state) =>
    state.activeSessionId
      ? (state.sessions[state.activeSessionId] ?? null)
      : null,
  );
